import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ContentBlockSection } from './styles/ContentBlock.styled';
import { ColumnSeven, Column, Innercontent } from './styles/Column.styled';

export default function ContentBlockDefault({
  grayBackground,
  imageOnRight,
  paragraphs,
  title,
  image,
  id,
}) {
  const isBrowser = typeof window !== 'undefined';
  const [, setInnerWidth] = React.useState(isBrowser && window.innerWidth);
  // innerWidth < 576

  React.useEffect(() => {
    if (isBrowser) window.addEventListener('resize', () => setInnerWidth(window.innerWidth));
  });

  return (
    <ContentBlockSection className={grayBackground && 'gray'} id={id}>
      <Container>
        <Row className={imageOnRight && 'right'}>
          <Column>
            <Innercontent>
              <h3>{title}</h3>
              {paragraphs.map((paragraph) => (
                <p>{paragraph}</p>
              ))}
            </Innercontent>
          </Column>
          <ColumnSeven>
            <LazyLoadImage
              src={image.url}
              alt={image.name}
              className="width_100"
              effect="blur"
              placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
            />
          </ColumnSeven>
        </Row>
      </Container>
    </ContentBlockSection>
  );
}
